import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import RouteConfig from "../system/routes";
import { clearStorage, getUserData } from "../system";
import ProfileModal from "./ProfileModal";

const SharedSidebar = ({ onNavClick }) => {
  const [screens, setScreens] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const Logout = () => {
    clearStorage();
    navigate("/login");
  };

  useEffect(() => {
    const decryptedData = getUserData();
    if (decryptedData) {
      setIsSuperAdmin(!!decryptedData.is_super_admin);
      setCompanyName(decryptedData.company?.name || "");
      if (decryptedData.is_super_admin) {
        const platformScreens = RouteConfig.PrivateRoutes.filter(
          (route) => route.screenId === 100 || route.screenId === 101
        );
        setScreens(platformScreens);
      } else if (Array.isArray(decryptedData.user_permissions)) {
        const filteredScreens = RouteConfig.PrivateRoutes.filter((route) =>
          decryptedData.user_permissions.some(
            (perm) => perm.permission_id === route.screenId
          )
        );
        setScreens(filteredScreens);
      }
    }
  }, []);

  return (
    <div className="app-menu navbar-menu">
      <ProfileModal show={showModal} onHide={() => setShowModal(false)} />
      
      {/* Dark Logo Brand Box */}
      <div className="navbar-brand-box">
        <NavLink to={isSuperAdmin ? "/platform-dashboard" : "/dashboard"} className="logo logo-dark">
          {isSuperAdmin ? (
            <img src="assets/images/logo-blacksilk.png" alt="Blacksilk" height={28} style={{ display: "block", maxWidth: "90%", objectFit: "contain" }} />
          ) : (
            <h2 className="text-white m-0 p-0 fw-bold text-truncate" style={{ fontSize: "1.25rem", letterSpacing: "-0.5px" }}>
              {companyName || process.env.REACT_APP_NAME}
            </h2>
          )}
        </NavLink>
      </div>

      {/* Light & Smart Menu List */}
      <div id="scrollbar">
        <div className="container-fluid pt-3 ps-0 pe-0">
          <ul className="navbar-nav app-menu-list" id="navbar-nav">
            {screens.map((route, idx) => (
              <li className="nav-item" key={idx}>
                <NavLink
                  to={route.path}
                  end
                  className={({ isActive }) =>
                    `nav-link menu-link ${isActive ? "active" : ""}`
                  }
                  onClick={onNavClick}
                >
                  <i className={route.icon} />
                  <span>{route.name}</span>
                </NavLink>
              </li>
            ))}
          </ul>
          
          <ul className="navbar-nav app-menu-list bottom-fixed" id="navbar-nav">
            <li className="nav-item" key="profile">
              <NavLink
                to=""
                onClick={() => Logout()}
                end
                className="nav-link menu-link text-danger-hover"
              >
                <i className="mdi mdi-logout text-danger" />
                <span className="text-danger">Logout</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </div>

      <style>{`
        .navbar-menu, .app-menu {
          background: #111827 !important;
          border-right: none !important;
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08) !important;
          border-radius: 0px !important;
          border-top-right-radius: 0px !important;
          border-bottom-right-radius: 0px !important;
        }
        .navbar-brand-box {
          background: #111827 !important;
          height: 70px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 10px 16px !important;
          border-radius: 0px !important;
          border-top-right-radius: 0px !important;
          border-bottom-right-radius: 0px !important;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
        }
        .navbar-brand-box .logo-dark {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          text-decoration: none !important;
        }
        .app-menu-list {
          padding-left: 0 !important;
          margin-bottom: 0 !important;
        }
        .app-menu-list .nav-item {
          border-bottom: 1px solid rgba(255, 255, 255, 0.04) !important;
        }
        .app-menu-list .nav-item:last-of-type {
          border-bottom: none !important;
        }
        .app-menu-list .nav-link {
          color: #9ca3af !important;
          font-weight: 600 !important;
          font-size: 0.88rem !important;
          padding: 12px 24px !important;
          border-radius: 0px !important;
          margin: 0 !important;
          display: flex !important;
          align-items: center !important;
          transition: all 0.2s ease !important;
          text-decoration: none !important;
        }
        .app-menu-list .nav-link i {
          color: #6b7280 !important;
          font-size: 1.2rem !important;
          margin-right: 12px !important;
          transition: all 0.2s ease !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .app-menu-list .nav-link:hover {
          color: #ffffff !important;
          background: rgba(25, 35, 51, 0.25) !important;
        }
        .app-menu-list .nav-link:hover i {
          color: #ffffff !important;
        }
        .app-menu-list .nav-link.active {
          color: #ffffff !important;
          background: #294365 !important;
          box-shadow: 0 4px 12px 0 rgba(41, 67, 101, 0.15) !important;
        }
        .app-menu-list .nav-link.active i {
          color: #ffffff !important;
        }
        .bottom-fixed {
          border-top: 1px solid rgba(255, 255, 255, 0.05) !important;
          padding: 0 !important;
          margin: 0 !important;
          height: 60px !important;
          display: flex !important;
          align-items: center !important;
        }
        .bottom-fixed .nav-item {
          border-bottom: none !important;
          width: 100% !important;
        }
        .text-danger-hover:hover {
          background: rgba(220, 53, 69, 0.08) !important;
        }
        .text-danger-hover:hover i,
        .text-danger-hover:hover span {
          color: #ef4444 !important;
        }
      `}</style>
    </div>
  );
};

export default SharedSidebar;
